import { useState } from "react";
import { computePrice } from "@/lib/pricing";
import { trackOnce } from "@/lib/analytics";

export function useCalculator(scrollTo, onPrefill) {
  const [unlocked, setUnlocked] = useState(
    () => window.localStorage.getItem("att_calc_unlocked") === "1"
  );
  const [indoor, setIndoor] = useState(1);
  const [outdoor, setOutdoor] = useState(1);
  const [high, setHigh] = useState(0);
  const [far, setFar] = useState(false);

  const tracked = (setter) => (v) => {
    trackOnce("calc_used");
    setter(v);
  };

  const setOutdoorClamped = (v) => {
    setOutdoor(v);
    if (high > v) setHigh(v);
  };

  const result = computePrice({ indoor, outdoor, high, far });

  const handleBookClick = () => {
    trackOnce("calc_book_click");
    if (onPrefill) onPrefill({ indoor, outdoor, high, far, total: result.total });
    scrollTo("booking");
  };

  return {
    unlocked,
    unlock: () => setUnlocked(true),
    state: { indoor, outdoor, high, far },
    actions: {
      setIndoor: tracked(setIndoor),
      setOutdoorClamped: tracked(setOutdoorClamped),
      setHigh: tracked(setHigh),
      setFar: tracked(setFar),
    },
    handleBookClick,
    result,
  };
}
